import { render, staticRenderFns } from "./PartnerSettings.vue?vue&type=template&id=31efcc6b&scoped=true&"
import script from "./PartnerSettings.vue?vue&type=script&lang=ts&"
export * from "./PartnerSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31efcc6b",
  null
  
)

export default component.exports